/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 30/09/2022.
 */
import React from 'react'

const SectionHeadline = ({ headline, sub }) => {
  return (
    <div className="col-10 mx-auto mb-md-6 mb-6 d-flex align-items-center flex-column">
      <div className="">
        <h3 className="fw-bold text-center mb-1 mb-md-2">{headline}</h3>
        <h6 className="text-center " style={{ maxWidth: 500 }}>
          {sub}
        </h6>
      </div>
    </div>
  )
}

export default SectionHeadline
